import React from 'react';
import { Plus } from 'lucide-react';

const AlternativeSchools = ({ tier, alternatives }) => {
  if (!alternatives || alternatives.length === 0) return null;

  // Tier colors for badge
  const tierBadgeColors = {
    reach: 'bg-coral-100 text-coral-700',
    target: 'bg-teal-100 text-teal-700',
    safety: 'bg-gold-100 text-gold-700'
  };

  const badgeColor = tierBadgeColors[tier] || tierBadgeColors.target;

  return (
    <div className="bg-white border-2 border-slate-300 rounded-lg p-6">
      <h3 className="text-lg font-bold text-slate-900 mb-3">
        Alternative {tier.charAt(0).toUpperCase() + tier.slice(1)} Schools to Consider
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {alternatives.map((alt, idx) => {
          // Extract acceptance rate if available
          const acceptanceRate = alt.acceptance_rate || alt.stats?.match(/(\d+)%/)?.[1];
          const acceptPercent = acceptanceRate ? parseInt(acceptanceRate) : null;

          return (
            <div key={idx} className="bg-stone-50 border border-slate-200 rounded-lg p-4">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <div className="font-semibold text-slate-900">{alt.name}</div>
                  <div className="text-xs text-slate-600">
                    {alt.location || (alt.city && alt.state ? `${alt.city}, ${alt.state}` : '')}
                    {alt.enrollment && ` • ${alt.enrollment}`}
                  </div>
                </div>
                {acceptPercent && (
                  <div className={`${badgeColor} px-2 py-0.5 rounded text-xs font-semibold whitespace-nowrap`}>
                    {acceptPercent}% accept
                  </div>
                )}
              </div>
              <p className="text-xs text-slate-700 mb-3 leading-relaxed">
                {alt.reason || alt.why_good_fit || 'Strong fit based on your profile and interests.'}
              </p>
              {alt.adds && (
                <p className="text-xs text-slate-600 mb-3 leading-relaxed">
                  <strong>Adds to portfolio:</strong> {alt.adds}
                </p>
              )}
              {alt.stats && !acceptanceRate && (
                <p className="text-xs text-slate-600 leading-relaxed">
                  <strong>Key stats:</strong> {alt.stats}
                </p>
              )}
              <button className="text-xs font-semibold text-teal-600 hover:text-teal-700 flex items-center gap-1 mt-2">
                <Plus className="w-3 h-3" />
                Add to List
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AlternativeSchools;
